<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            title="Data Submitted"
            centered
            @ok="clearFields"
        >
            <div class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
        </b-modal>
      <b-container fluid>
        <h2 class="tw-mb-0 text-aegis-dk">FRNT Processing</h2>
        <p class="tw-italic tw-text-gray-700">
          Blood sample processing
        </p>
      </b-container>
      <br />
  
      <!-- Show this row when page first loads -->
      <b-row v-if="blood_sample_id == ''">
        <b-col cols="3"></b-col>
        <b-col cols="4">
            <b-form-input
                v-model="aliquot_id"
                placeholder="Scan Aliquot Barcode"
                @keypress.enter="getData"
            ></b-form-input>
        </b-col>
        <b-col cols="2">
            <b-button
                @click="getData()"
                :disabled="aliquot_id == ''"
            >Submit</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
      <!-- Show this after we know which Blood Sample Analysis object we need -->
      <b-row v-else>
        <b-col cols="2"></b-col>
        <b-col cols="8">
            <b-row>
                <b-col><h5>FRNT Processing for Blood Sample ID: {{ blood_sample_id }}</h5></b-col>
            </b-row>
            <span v-for="(row, index) in chunks" :key="row.key">
                <b-row v-if="index == 0"><b-col>Dengue V1 Foci Counts:</b-col></b-row>
                <b-row v-if="index == 5"><b-col>Dengue V2 Foci Counts:</b-col></b-row>
                <b-row v-if="index == 10"><b-col>Dengue V3 Foci Counts:</b-col></b-row>
                <b-row v-if="index == 15"><b-col>Dengue V4 Foci Counts:</b-col></b-row>
                <b-row class="mt-2">
                    <b-col v-for="col in row" :key="col.key">
                        <b-form-group
                            :id="col.key"
                            :label=col.text
                        >
                            <b-form-input
                                :label="col.text"
                                v-model="col.value"
                                :placeholder=col.text
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </span>
            <b-button
                class="mt-2"
                variant="success"
                size="lg"
                block
                @click="getData('update')"
                :disabled="processing_submit_disabled"
            >Submit Data</b-button>
        </b-col>
        <b-col cols="2"></b-col>
      </b-row>
    </div>
  </template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as _ from "lodash";
  
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
data: function() {
    return {
        showModal: false,
        ModalMessage: '',
        blood_sample_id: '',
        blood_sample_analysis_id: '',
        aliquot_id: '',
        form_fields: [
            // V1
            { key: 'frnt_dengue_v1_foci_count_1to10', value: '', text: 'V1 1:10' },
            { key: 'frnt_dengue_v1_foci_percent_neutralization_1to10', value: '', text: 'V1 % Neutralization' },
            { key: 'frnt_dengue_v1_foci_count_1to40', value: '', text: 'V1 1:40' },
            { key: 'frnt_dengue_v1_foci_percent_neutralization_1to40', value: '', text: 'V1 % Neutralization' },
            { key: 'frnt_dengue_v1_foci_count_1to160', value: '', text: 'V1 1:160' },
            { key: 'frnt_dengue_v1_foci_percent_neutralization_1to160', value: '', text: 'V1 % Neutralization' },
            { key: 'frnt_dengue_v1_foci_count_1to640', value: '', text: 'V1 1:640' },
            { key: 'frnt_dengue_v1_foci_percent_neutralization_1to640', value: '', text: 'V1 % Neutralization' },
            { key: 'frnt_dengue_v1_foci_count_1to2650', value: '', text: 'V1 1:2650' },
            { key: 'frnt_dengue_v1_foci_percent_neutralization_1to2650', value: '', text: 'V1 % Neutralization' },
            // V2
            { key: 'frnt_dengue_v2_foci_count_1to10', value: '', text: 'V2 1:10' },
            { key: 'frnt_dengue_v2_foci_percent_neutralization_1to10', value: '', text: 'V2 % Neutralization' },
            { key: 'frnt_dengue_v2_foci_count_1to40', value: '', text: 'V2 1:40' },
            { key: 'frnt_dengue_v2_foci_percent_neutralization_1to40', value: '', text: 'V2 % Neutralization' },
            { key: 'frnt_dengue_v2_foci_count_1to160', value: '', text: 'V2 1:160' },
            { key: 'frnt_dengue_v2_foci_percent_neutralization_1to160', value: '', text: 'V2 % Neutralization' },
            { key: 'frnt_dengue_v2_foci_count_1to640', value: '', text: 'V2 1:640' },
            { key: 'frnt_dengue_v2_foci_percent_neutralization_1to640', value: '', text: 'V2 % Neutralization' },
            { key: 'frnt_dengue_v2_foci_count_1to2650', value: '', text: 'V2 1:2650' },
            { key: 'frnt_dengue_v2_foci_percent_neutralization_1to2650', value: '', text: 'V2 % Neutralization' },
            // V3
            { key: 'frnt_dengue_v3_foci_count_1to10', value: '', text: 'V3 1:10' },
            { key: 'frnt_dengue_v3_foci_percent_neutralization_1to10', value: '', text: 'V3 % Neutralization' },
            { key: 'frnt_dengue_v3_foci_count_1to40', value: '', text: 'V3 1:40' },
            { key: 'frnt_dengue_v3_foci_percent_neutralization_1to40', value: '', text: 'V3 % Neutralization' },
            { key: 'frnt_dengue_v3_foci_count_1to160', value: '', text: 'V3 1:160' },
            { key: 'frnt_dengue_v3_foci_percent_neutralization_1to160', value: '', text: 'V3 % Neutralization' },
            { key: 'frnt_dengue_v3_foci_count_1to640', value: '', text: 'V3 1:640' },
            { key: 'frnt_dengue_v3_foci_percent_neutralization_1to640', value: '', text: 'V3 % Neutralization' },
            { key: 'frnt_dengue_v3_foci_count_1to2650', value: '', text: 'V3 1:2650' },
            { key: 'frnt_dengue_v3_foci_percent_neutralization_1to2650', value: '', text: 'V3 % Neutralization' },
            // V4
            { key: 'frnt_dengue_v4_foci_count_1to10', value: '', text: 'V4 1:10' },
            { key: 'frnt_dengue_v4_foci_percent_neutralization_1to10', value: '', text: 'V4 % Neutralization' },
            { key: 'frnt_dengue_v4_foci_count_1to40', value: '', text: 'V4 1:40' },
            { key: 'frnt_dengue_v4_foci_percent_neutralization_1to40', value: '', text: 'V4 % Neutralization' },
            { key: 'frnt_dengue_v4_foci_count_1to160', value: '', text: 'V4 1:160' },
            { key: 'frnt_dengue_v4_foci_percent_neutralization_1to160', value: '', text: 'V4 % Neutralization' },
            { key: 'frnt_dengue_v4_foci_count_1to640', value: '', text: 'V4 1:640' },
            { key: 'frnt_dengue_v4_foci_percent_neutralization_1to640', value: '', text: 'V4 % Neutralization' },
            { key: 'frnt_dengue_v4_foci_count_1to2650', value: '', text: 'V4 1:2650' },
            { key: 'frnt_dengue_v4_foci_percent_neutralization_1to2650', value: '', text: 'V4 % Neutralization' }
        ],
    };
},
computed: {
    processing_submit_disabled:function () {
        let disabled = false;
        _.each(this.form_fields, function(field) {
            if (field.value == null || field.value == '') {
                disabled = true;
            }
        });
        return disabled;
    },
    chunks:function () {
        return _.chunk(this.form_fields, 2);
    }
},
watch: {},
created: function() {},
mounted: function() {},
methods: {
    getData: function(mode = null) {
        const that = this;
        const fd = new FormData();
        fd.append("aliquot_id", that.aliquot_id);
        
        if (mode == "update") {
            fd.append("mode", mode);
            _.each(this.form_fields, function(field) {
                fd.append(field.key, field.value);
            });
        }
        HTTP.post('srilanka/blood_sample/frnt_processing/', fd).then((response) => {
            that.blood_sample_id = response.data.blood_sample_id;
            that.blood_sample_analysis_id = response.data.blood_sample_analysis_id;

            _.each(that.form_fields, function(field) {
                field.value = response.data[field.key];
            });
            if (mode == 'update') {
                this.ModalMessage = 'Submitted successfully';
                this.showModal = true;
            }
        }).catch((error) => {
            this.ModalMessage = 'There was a problem. Please check input values and try again.';
            this.showModal = true;
            HandleErrors.HandleErrors(error);
        });
    },
    clearFields() {
        this.blood_sample_id = '';
        this.blood_sample_analysis_id = '';
        this.aliquot_id = '';
        _.each(this.form_fields, function(field) {
            field.value = '';
        });
    }
}
};
</script>

<style scoped></style>
  